var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-sent.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-88c2a29c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-sent.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageSent.vue
// module id = 1314
// module chunks = 1